import { Offcanvas } from 'react-bootstrap';

const ViewHistoryOffcanvas = ({
    show,
    onHide,
    historyList
}) => {
    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header className='px-4 py-3' closeButton>
                <Offcanvas.Title className='display-1'>Projects History</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='p-4'>
                <div>
                    {historyList.length > 0 ? (
                        historyList.map((item, index) => (
                            <div key={index} className='border p-3 rounded-3 mb-3'>
                                <div className='p-tag fs-12'>
                                    {item.date} at {item.time}
                                </div>
                                <div className='p-tag fw-bold border-bottom pb-2'>{item.user}</div>
                                <div className='p-tag mt-2'>
                                    {item.type === 'time' && (
                                        <div className="p-tag">
                                            <strong>Time Log:</strong> {item.duration}
                                        </div>
                                    )}
                                    <div className="p-tag">
                                        {item.action}
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-center text-muted py-4">
                            No history to display
                        </div>
                    )}
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default ViewHistoryOffcanvas;
